import {bigTechSkin} from '~/game/skins/bigTech'
import type {TSkinData} from '~/game/skins/types'

export {bigTechSkin}

export type TSkin = 'bigTech'

export const skins: Record<TSkin, TSkinData> = {
  bigTech: bigTechSkin,
}

export const skinsHuman: Record<TSkin, string> = {
  bigTech: 'Big Tech',
}
